import React, { useEffect } from 'react';
import VideoPlayer from './components/VideoPlayer';
import Timeline from './components/Timeline';
import TrackList from './components/TrackList';
import ExportDialog from './components/ExportDialog';
import { useVideoStore } from './store/videoStore';
import { useTimelineStore } from './store/timelineStore';
import { useHistoryStore } from './store/historyStore';
import './styles/global.css';

const { ipcRenderer } = window.require ? window.require('electron') : { ipcRenderer: null };

function App() {
  const { setVideoFile, togglePlay } = useVideoStore();
  const { addClip, exportTrack } = useTimelineStore();
  const { undo, redo } = useHistoryStore();

  useEffect(() => {
    // 只在Electron环境中注册事件监听
    if (!ipcRenderer) return;

    // 监听 Electron 菜单事件
    const handleOpenVideo = (event, filePath) => {
      setVideoFile(filePath);
    };

    const handleTogglePlay = () => {
      togglePlay();
    };

    const handleOffenseClip = () => {
      addClip('offense');
    };

    const handleDefenseClip = () => {
      addClip('defense');
    };

    const handleUndo = () => {
      undo();
    };

    const handleRedo = () => {
      redo();
    };

    const handleExportTrack = () => {
      exportTrack();
    };

    // 注册事件监听
    ipcRenderer.on('open-video', handleOpenVideo);
    ipcRenderer.on('toggle-play', handleTogglePlay);
    ipcRenderer.on('offense-clip', handleOffenseClip);
    ipcRenderer.on('defense-clip', handleDefenseClip);
    ipcRenderer.on('undo', handleUndo);
    ipcRenderer.on('redo', handleRedo);
    ipcRenderer.on('export-track', handleExportTrack);

    // 清理事件监听
    return () => {
      ipcRenderer.removeListener('open-video', handleOpenVideo);
      ipcRenderer.removeListener('toggle-play', handleTogglePlay);
      ipcRenderer.removeListener('offense-clip', handleOffenseClip);
      ipcRenderer.removeListener('defense-clip', handleDefenseClip);
      ipcRenderer.removeListener('undo', handleUndo);
      ipcRenderer.removeListener('redo', handleRedo);
      ipcRenderer.removeListener('export-track', handleExportTrack);
    };
  }, [setVideoFile, togglePlay, addClip, undo, redo, exportTrack, ipcRenderer]);

  return (
    <div className="app">
      <div className="app-header">
        <h1>篮球战术剪辑器</h1>
      </div>
      
      <div className="app-content">
        <VideoPlayer />
        <Timeline />
        <TrackList />
      </div>
      
      <ExportDialog />
    </div>
  );
}

export default App;